export const SHIP_IMAGES = {
  carriers: [
    "./image/Carrier front.png",
    "./image/Carrier middle1.png",
    "./image/Carrier middle2.png",
    "./image/Carrier middle3.png",
    "./image/Carrier back.png",
  ],
  battleships: [
    "./image/Battleship front.png",
    "./image/Battleship middle1.png",
    "./image/Battleship middle2.png",
    "./image/Battleship back.png",
  ],
  cruisers: [
    "./image/Cruiser front.png",
    "./image/Cruiser middle.png",
    "./image/Cruiser back.png",
  ],
  submarines: [
    "./image/Submarine front.png",
    "./image/Submarine middle.png",
    "./image/Submarine back.png",
  ],
  destroyers: ["./image/Destroyer front.png", "./image/Destroyer back.png"],
};

export const getShipImage = (type, index) => {
  const shipParts = SHIP_IMAGES[type];
  return shipParts && shipParts[index];
};
